// extracted by mini-css-extract-plugin
module.exports = {"bg":"styles_bg__uW7Ty"};